import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

interface Folder {
  id: number;
  title: string;
  pinned: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  messages: Array<any>;
}

interface FolderState {
  folders: Folder[];
  isLoading: boolean;
  error: string | null;
}

// Initial state
const initialState: FolderState = {
  folders: [],
  isLoading: false,
  error: null,
};

// Fetch folders from API
export const fetchFolders = createAsyncThunk("folders/fetchFolders", async () => {
  const response = await axios.get("/api/folders");
  return response.data;
});

const sidebarFolderSlice = createSlice({
  name: "folders",
  initialState,
  reducers: {
    addFolder: (state, action: PayloadAction<Folder>) => {
      state.folders.push(action.payload);
    },
    editFolder: (state, action: PayloadAction<{ id: number; data: Partial<Folder> }>) => {
      const folder = state.folders.find((folder) => folder.id === action.payload.id);
      if (folder) {
        Object.assign(folder, action.payload.data);
      }
    },
    deleteFolder: (state, action: PayloadAction<number>) => {
      state.folders = state.folders.filter((folder) => folder.id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFolders.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchFolders.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(fetchFolders.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message ?? "Failed to fetch folders";
      });
  },
});

export const { addFolder, editFolder, deleteFolder } = sidebarFolderSlice.actions;
export default sidebarFolderSlice.reducer;
